// LLM generated - Model Claude 4 Sonnet
import { SERVICE_FEE_ALERT_TYPES } from '~/domains/contest/domains/common/constants';
import type { ServiceFeeAlert } from '~/domains/manage-contest/types';

import type { Alert } from '../services/interfaces/full-contest.interface';
import { isServiceFeeAlert } from '../services/utils/alertFilters';

/**
 * Contest Alert Manager - Single API for contest alert operations
 * Provides high-level, business-focused methods for service fee alerts
 */
export class ContestAlertManager {
  private alerts: Alert[];

  constructor(alerts?: { values: Alert[] }) {
    this.alerts = alerts?.values || [];
  }

  /**
   * Get the first service fee alert (most common use case)
   */
  getFirstServiceFeeAlert(): ServiceFeeAlert | null {
    return this.alerts.find(isServiceFeeAlert) || null;
  }

  /**
   * Check for specific service fee alert types
   */
  hasServiceFeeDue(): boolean {
    return this.alerts.some(
      (alert) => isServiceFeeAlert(alert) && alert.type === SERVICE_FEE_ALERT_TYPES.SERVICE_FEE_DUE
    );
  }

  hasServiceFeeOverdue(): boolean {
    return this.alerts.some(
      (alert) =>
        isServiceFeeAlert(alert) && alert.type === SERVICE_FEE_ALERT_TYPES.SERVICE_FEE_OVERDUE
    );
  }

  hasServiceFeeCancelled(): boolean {
    return this.alerts.some(
      (alert) =>
        isServiceFeeAlert(alert) && alert.type === SERVICE_FEE_ALERT_TYPES.SERVICE_FEE_CANCELLED
    );
  }
}
